import SvgIcon from 'common/components/svg-icon';


const TumblrIcon = (props) => (
    <SvgIcon { ...props }>
        <path
            clipRule='evenodd'
            d='m20.794,22.282l0,5.579l2.79,0l0,8.37c0.22,6.844 3.982,8.27 8.369,8.742c2.55,-0.128 5.674,-1.072 7.253,-2.326l0,-4.742c-2.031,1.974 -7.484,3.91 -8.462,-1.674l-0.094,-8.462l8.556,0.093l0,-5.672l-8.556,0l0.187,-7.161l-3.44,0.093c0.236,6.107 -3.01,6.925 -6.603,7.16zm-20.794,-22.282l60,0l0,60l-60,0l0,-60z'
            fillRule='evenodd'
        />
    </SvgIcon>
);


export default TumblrIcon;



// WEBPACK FOOTER //
// ./src/common/components/svg-icon/tumblr.js